module.exports = __webpack_public_path__ + "public/SiteIcons/avatar.png?5531e111";